export default function HeroSection() {
  return (
    <section className="relative h-screen min-h-[700px] w-full flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20composition%20with%20warm%20neutral%20cream%20and%20beige%20tones%2C%20architectural%20minimalism%2C%20soft%20diffused%20natural%20lighting%20casting%20gentle%20shadows%2C%20layered%20translucent%20organic%20shapes%20intersecting%2C%20elegant%20sophisticated%20atmosphere%2C%20clean%20precise%20lines%20blending%20with%20soft%20curves%2C%20modern%20corporate%20aesthetic%2C%20subtle%20texture%20and%20depth%2C%20professional%20editorial%20photography%20style%20with%20warm%20undertones&width=1600&height=900&seq=hero-bg-elr-01&orientation=landscape"
          alt="Abstract geometric background with warm tones and architectural minimalism"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="mb-8">
          <span className="inline-block px-6 py-2 rounded-full border border-white/30 text-white/80 text-sm tracking-widest uppercase" style={{ fontFamily: 'var(--font-label)' }}>
            Professional Engineering
          </span>
        </div>

        <h1 className="text-5xl md:text-7xl lg:text-8xl xl:text-9xl text-white leading-none tracking-tight" style={{ fontFamily: 'var(--font-heading)' }}>
          ELR Digital OU
        </h1>

        <div className="mt-10 md:mt-12 max-w-2xl mx-auto">
          <p className="text-white/60 text-base md:text-lg leading-relaxed tracking-wide" style={{ fontFamily: 'var(--font-body)' }}>
            Designing and developing modern digital software solutions
            <br className="hidden sm:block" />
            for the iOS platform and related technologies
          </p>
        </div>

        <div className="mt-16">
          <div className="w-16 h-px bg-white/20 mx-auto"></div>
        </div>
      </div>
    </section>
  );
}